import React from 'react';

const TitlePage = (props) => {
    return (
        <div className="section-title">
            <h2>{props.heading}</h2>
            {props.backgroundText && (
                <div className="section-subtitle">{props.backgroundText}</div>
            )}
            <span className="section-separator"></span>
            {props.text && (
                <p>{props.text}</p>
            )}
        </div>
    );
};

export default TitlePage;